const Button = ({
  label,
  icon,
  onClick,
  value,
  type = "button",
  variant = "primary",
  disabled = false,
  className = "",
}) => {
  const baseStyle =
    "px-3 py-2 rounded-md font-medium transition duration-200 flex items-center justify-center gap-2";

  const variants = {
    primary:
      "bg-gray-200 text-black hover:bg-gray-300 transition-colors duration-200 rounded-md font-semibold",
    secondary: "bg-gray-200 text-gray-800 hover:bg-gray-300",
    update: "bg-green-500 text-white, hover:bg-green-600",
    remove: "bg-red-500 text-white hover:bg-red-600",
    outline:
      "border border-[#004BA8] text-[#004BA8] hover:bg-[#004BA8] hover:text-white",
  };

  return (
    <button
      value={value}
      type={type}
      onClick={onClick}
      disabled={disabled}
      className={`
        ${baseStyle}
        ${variants[variant]}
        ${disabled ? "opacity-50 cursor-not-allowed" : ""}
        ${className}
      `}
    >
      {icon && <span className="flex items-center">{icon}</span>}
      <span>{label}</span>
    </button>
  );
};

export default Button;
